import PayGas from './PayGas'

export default PayGas
